module.exports = __webpack_public_path__ + "img/sel_Hong Kong.14651d5e.png";